import React, { Component } from 'react';
import './HeaderGameInfo.css';

const winningIndicatorStyle = { textShadow: '2px 2px #000' };

class HeaderGameInfo extends Component {

    constructor(props) {
        super(props);
    }

    getGameStateComponent() {
        const clock = (this.props.clock.includes(":")) ? (this.props.clock) : (":" + this.props.clock);
        const gameStateFinal = (
            <div className="final">
                Final{this.props.period.current > 4 && ('/OT')}
                <div className="game-result">{this.props.game_text}</div>
            </div >
        );
        const gameStateInProgress = (
            <div className="game-state">
                <div className="game-quarter">Q{this.props.period.current}</div>
                <div className="game-countdown">{clock}</div>
            </div>
        );
        const gameStateInProgressOvertime = (
            <div className="game-state">
                <div className="game-quarter">OT{(this.props.period.current - 4)}</div>
                <div className="game-countdown">{clock}</div>
            </div>
        );
        const gameStateHalftime = (
            <div className="game-state">
                <div className="game-quarter">Halftime</div>
            </div>
        );
        const gameStateEndOfQuarter = (
            <div className="game-state">
                <div className="game-quarter">End of Q{this.props.period.current}</div>
            </div>
        );
        const gameStateEndOfQuarterOvertime = (
            <div className="game-state">
                <div className="game-quarter">End of OT{this.props.period.current - 4}</div>
            </div>
        );
        const gameStateNotStarted = (
            <div className="pre-game-text final">{this.props.start_time}</div>
        );
        var gameState;

        switch (this.props.status_num) {
            // Game has yet to start
            case 1:
                gameState = gameStateNotStarted;
                break;
            // Game in progress (Still need to code for overtime edge cases)
            case 2:
                if (this.props.period.isHalftime) {
                    gameState = gameStateHalftime;
                    break;
                } else if (this.props.period.isEndOfPeriod) {
                    if (this.props.period.current > 4) {
                        gameState = gameStateEndOfQuarterOvertime;
                    } else {
                        gameState = gameStateEndOfQuarter;
                    }
                    break;
                }
                if (this.props.period.current > 4) {
                    gameState = gameStateInProgressOvertime;
                } else {
                    gameState = gameStateInProgress;
                }
                break;
            // Game over
            case 3:
                gameState = gameStateFinal;
                break;
        }
        return gameState;
    }

    getStylesForWinner() {
        var indicator = {
            homeWin: {},
            awayWin: {},
        }
        if (this.props.status_num === 3) {
            if (parseInt(this.props.hTeamScore) > parseInt(this.props.vTeamScore)) {
                indicator.homeWin = winningIndicatorStyle;
            } else {
                indicator.awayWin = winningIndicatorStyle;
            }
        }
        return indicator;
    }

    render() {
        const gameState = this.getGameStateComponent();
        const indicator = this.getStylesForWinner();
        let gameInfoClass = "game-info";
        if (this.props.status_num === 1) {
            gameInfoClass += " pre-game";
        }
        return (
            <div className={gameInfoClass}>
                <div className="info-wrap">
                    <div className="game-score">
                        {this.props.status_num !== 1 && <div className="away-score" style={indicator.awayWin}>{this.props.vTeamScore}</div>}
                        {gameState}
                        {this.props.status_num !== 1 && <div className="home-score" style={indicator.homeWin}>{this.props.hTeamScore}</div>}
                    </div>
                </div>
            </div >
        );
    }
}

export default HeaderGameInfo;
